<template>
  <p class="mt-3 mb-3 baseColor">{{ $t("COPYRIGHT.TEXT") }}<br>&copy; {{ getCurrentYear() }}</p>
</template>

<script>
import moment from 'moment';

export default {
  name: 'Copyright',
  components: {},
  methods: {
    getCurrentYear() {
      return moment().format('YYYY');
    },
  },
};
</script>

<style scoped lang="scss">
</style>
